import React from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import TitleList from "../TitleList/TitleList";
import "./TitleListContainer.css";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import {
  loadTitleRequestAction,
  filterKeywordEnteredAction,
  delTitleRequestAction,
  showCreateAction,
  hideCreateAction,
  createTitleRequestAction,
  editTitleAction,
  editTitleRequestAction
} from "../../redux/actions/titleList";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import CreateTitleModal from "../CreateTitleModal/CreateTitleModal";
import { withCookies } from "react-cookie";

class TitleListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.filterEntered = this.filterEntered.bind(this);
    this.createPressed = this.createPressed.bind(this);
    this.handCloseCreateModal = this.handCloseCreateModal.bind(this);
    this.handleEnterCreatingTitle = this.handleEnterCreatingTitle.bind(this);
    this.handleEnterCreatingProdTitle = this.handleEnterCreatingProdTitle.bind(
      this
    );
    this.handleFireCreateTitle = this.handleFireCreateTitle.bind(this);
    this.handleEditFire = this.handleEditFire.bind(this);

    this.state = {
      creatingTitle: "",
      creatingProdTitle: ""
    };
  }

  componentDidMount() {
    if (!this.props.loaded) {
      this.props.loadTitleRequestAction();
    }
  }

  handleEnterCreatingTitle(event) {
    this.setState({
      creatingTitle: event.target.value
    });
  }

  handleEnterCreatingProdTitle(event) {
    this.setState({
      creatingProdTitle: event.target.value
    });
  }

  handleFireCreateTitle() {
    const title = this.state.creatingTitle;
    const prodTitle = this.state.creatingProdTitle;

    if (title == null || title === "") {
      toast.error("title cannot be empty");
      return;
    }

    this.props.createTitleRequestAction(title, prodTitle, toast);
  }

  createPressed() {
    this.setState({
      creatingTitle: "",
      creatingProdTitle: ""
    });
    this.props.showCreateAction();
  }

  handCloseCreateModal() {
    this.setState({
      creatingTitle: "",
      creatingProdTitle: ""
    });
    this.props.hideCreateAction();
  }

  handleEdit(id) {
    this.props.editTitleAction({ edittingTitleID: id });
  }

  handleDelete(aTitle) {
    this.props.delTitleRequestAction(aTitle, this.props.titles, toast);
  }

  filterEntered(event) {
    this.props.filterKeywordEnteredAction({ keyword: event.target.value });
  }

  handleEditFire(id, newName) {
    this.props.editTitleRequestAction(id, newName, toast);
  }

  renderSwitch() {
    if (!this.props.loaded) {
      return (
        <div className="title_load">
          <Spinner animation="grow" />
        </div>
      );
    } else if (this.props.errMsg != null) {
      return (
        <Alert variant="danger" className="title_error">
          {this.props.errMsg}
        </Alert>
      );
    } else {
      const {
        keyword,
        titles,
        cookies,
        editLoading,
        edittingTitleID
      } = this.props;

      return (
        <TitleList
          keyword={keyword}
          titles={titles}
          cookies={cookies}
          editLoading={editLoading}
          edittingTitleID={edittingTitleID}
          handleEditFire={this.handleEditFire}
          handleDelete={this.handleDelete}
          handleEdit={this.handleEdit}
        />
      );
    }
  }

  render() {
    const { cookies } = this.props;
    const isAdmin = cookies.get("role") === "admin";

    return (
      <React.Fragment>
        <Card bg="light" className="title_list_card">
          <Card.Header>
            <Form.Row>
              <Col xs="9" sm="9" md="8" lg="10" xl="10">
                <Form.Control
                  autoFocus
                  type="text"
                  value={this.props.keyword}
                  placeholder="Filter"
                  onChange={this.filterEntered}
                />
              </Col>
              {isAdmin && (
                <Col xs="3" sm="3" md="4" lg="2" xl="2">
                  <Button
                    className="create_title_btn"
                    variant="info"
                    onClick={this.createPressed}
                    disabled={this.props.isCreating}
                  >
                    Create
                  </Button>
                </Col>
              )}
            </Form.Row>
          </Card.Header>
          {this.renderSwitch()}
        </Card>

        <CreateTitleModal
          showCreateModal={this.props.showCreateModal}
          handleCloseCreateModal={this.handCloseCreateModal}
          creatingTitle={this.state.creatingTitle}
          creatingProdTitle={this.state.creatingProdTitle}
          handleEnterCreatingTitle={this.handleEnterCreatingTitle}
          handleEnterCreatingProdTitle={this.handleEnterCreatingProdTitle}
          handleFireCreateTitle={this.handleFireCreateTitle}
          isLoading={this.props.isCreating}
        />
      </React.Fragment>
    );
  }
}

const mapState = state => {
  const { titleList } = state;
  return titleList;
};

const mapDispatch = {
  loadTitleRequestAction,
  filterKeywordEnteredAction,
  delTitleRequestAction,
  showCreateAction,
  hideCreateAction,
  createTitleRequestAction,
  editTitleAction,
  editTitleRequestAction
};

export default withCookies(
  connect(
    mapState,
    mapDispatch
  )(TitleListContainer)
);
